// App constants

// Product types
export const PRODUCT_TYPES = ['flower', 'preroll', 'vape', 'edible'] as const;

// Strain types
export const STRAIN_TYPES = ['indica', 'sativa', 'hybrid', 'unknown'] as const;

// Brand types
export const BRAND_TYPES = ['grower', 'processor', 'label'] as const;

// Rating scales
export const RATING_MIN = 1;
export const RATING_MAX = 10;

export const EFFECT_MIN = 0;
export const EFFECT_MAX = 10;

// Effect categories
export const EFFECT_CATEGORIES = [
    'anxiety',
    'body_high',
    'head_high',
    'creativity',
    'smoothness',
] as const;

export const EFFECT_LABELS = {
    anxiety: 'Anxiety Relief',
    body_high: 'Body High',
    head_high: 'Head High',
    creativity: 'Creativity',
    smoothness: 'Smoothness',
};

// Value score thresholds (configurable!)
export const VALUE_THRESHOLDS = {
    high: 50,    // Green badge: > 50
    medium: 25,  // Yellow badge: 25-50
    low: 0,      // Red badge: < 25
};

// Helper function to get value tier
export function getValueTier(score: number): 'high' | 'medium' | 'low' {
    if (score >= VALUE_THRESHOLDS.high) return 'high';
    if (score >= VALUE_THRESHOLDS.medium) return 'medium';
    return 'low';
}

// Helper function to get badge class
export function getValueBadgeClass(score: number): string {
    const tier = getValueTier(score);
    switch (tier) {
        case 'high':
            return 'badge-high';
        case 'medium':
            return 'badge-medium';
        case 'low':
            return 'badge-low';
    }
}

// Date formatting
export function formatDate(dateString: string): string {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    }).format(date);
}

// Price formatting
export function formatPrice(price: number): string {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(price);
}
